import { notFound } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import {
  composedServicePage,
  readBooking,
  readCoaching,
  readTournament,
  readTournaments,
} from "./services.server";
import { siteContext, publicationResponse } from "./site.server";

/** Coaching (/coaching) in one request: the composed page with the calendar at its built-in block, or the native page. */
export const loadCoaching = createServerFn({ method: "GET" }).handler(async ({ context }) => {
  const drate = await siteContext(context);
  const coaching = await readCoaching(drate);
  if (!coaching) return { kind: "missing" as const };
  const page = await composedServicePage(drate, "/coaching");
  publicationResponse(drate);
  if (page.kind === "redirect") return page;
  if (page.kind === "page") return { ...page, coaching };
  return { kind: "native" as const, coaching };
});

/** Appointments (/booking) in one request: the composed page with the booking form, or the native page. */
export const loadBooking = createServerFn({ method: "GET" }).handler(async ({ context }) => {
  const drate = await siteContext(context);
  const booking = await readBooking(drate);
  if (!booking) return { kind: "missing" as const };
  const page = await composedServicePage(drate, "/booking");
  publicationResponse(drate);
  if (page.kind === "redirect") return page;
  if (page.kind === "page") return { ...page, booking };
  return { kind: "native" as const, booking };
});

/** Tournaments (/tournaments) in one request: the composed page with the list, or the native page. */
export const loadTournaments = createServerFn({ method: "GET" }).handler(async ({ context }) => {
  const drate = await siteContext(context);
  const tournaments = await readTournaments(drate);
  if (!tournaments) return { kind: "missing" as const };
  const page = await composedServicePage(drate, "/tournaments");
  publicationResponse(drate);
  if (page.kind === "redirect") return page;
  if (page.kind === "page") return { ...page, tournaments };
  return { kind: "native" as const, tournaments };
});

/** One selected tournament (/tournaments/:id). */
export const loadTournament = createServerFn({ method: "GET" })
  .validator((id: unknown) => {
    if (typeof id !== "string" || !id || id.length > 200) throw notFound();
    return id;
  })
  .handler(async ({ data: id, context }) => readTournament(await siteContext(context), id));
